<script>
  import { fade } from 'svelte/transition'
</script>

<section class="mt-12 pt-16 rounded-3xl border border-am-white-60 overflow-hidden w-full">
  <div class="grid md:grid-cols-2 gap-16 lg:gap-24 max-w-6xl mx-auto mb-16 px-14 md:py-10 text-am-black-75">
    <!-- Mission Column -->
    <div class="space-y-6" in:fade={{ duration: 300, delay: 150 }}>
      <div class="w-12 h-12 hover-icon bg-[#536aff] rounded-full flex items-center justify-center mb-8">
        <span
          class="material-symbols-rounded text-white"
          style="font-size: 24px; font-variation-settings: 'FILL' 0, 'wght' 300;">arrow_upward</span
        >
      </div>

      <h2 class="text-4xl md:text-5xl font-bold">
        <span class="text-am-white-60">Our</span>
        <span class="text-[#070811]">Mission</span>
      </h2>

      <p>
        To help B2B professionals spend less time filtering noise and more time having the right conversations. By
        qualifying meetings before they happen, AddMeetings ensures every interaction is relevant, valuable, and worth
        your time creating space for meaningful business growth.
      </p>
    </div>

    <!-- Vision Column -->
    <div class="space-y-6" in:fade={{ duration: 300, delay: 300 }}>
      <div class="w-12 h-12 hover-icon bg-[#536aff] rounded-full flex items-center justify-center mb-8">
        <span
          class="material-symbols-rounded text-white"
          style="font-size: 24px; font-variation-settings: 'FILL' 0, 'wght' 300;">visibility</span
        >
      </div>

      <h2 class="text-4xl md:text-5xl font-bold">
        <span class="text-am-white-60">Our</span>
        <span class="text-[#070811]">Vision</span>
      </h2>

      <p>
        To redefine how business meetings happen, moving from cold, random outreach to intentional, qualified, and human
        conversations. We envision a world where professionals connect seamlessly with the right people, at the right
        time, for the right reasons.
      </p>
    </div>
  </div>

  <!-- Team Image -->
  <div class="w-full">
    <img
      src="/diverse-team-collaborating-in-a-meeting.jpeg"
      alt="Diverse team collaborating in a meeting"
      class="w-full h-auto object-cover rounded-b-2xl"
      style="max-height: 400px;"
    />
  </div>
</section>

<style>
  /* Optional: Add hover effect to icons */
  .hover-icon {
    transition: transform 0.2s ease;
  }

  .hover-icon:hover {
    transform: translateY(-2px);
  }
</style>
